module.exports = __webpack_public_path__ + "static/media/L2.1501bf4c.jpg";